document.addEventListener('DOMContentLoaded', function () {
    let editNewsButtons = document.querySelectorAll('.edit');
    editNewsButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            let newsId = this.getAttribute('data-news-id');
            let newsTitle = JSON.parse(this.getAttribute('data-news-title'));
            let newsContent = JSON.parse(this.getAttribute('data-news-content'));
            let newsPhoto = this.getAttribute('data-news-photo');

            document.getElementById('edit-id').value = newsId;

            document.getElementById('edit-title-ru').value = newsTitle['ru'] || '';
            document.getElementById('edit-title-tj').value = newsTitle['tj'] || '';
            document.getElementById('edit-title-en').value = newsTitle['en'] || '';

            document.getElementById('edit-content-ru').value = newsContent['ru'] || '';
            document.getElementById('edit-content-tj').value = newsContent['tj'] || '';
            document.getElementById('edit-content-en').value = newsContent['en'] || '';

            if (newsPhoto) {
                document.getElementById('current-photo').src = newsPhoto;
                document.getElementById('current-photo').style.display = 'block';
            } else {
                document.getElementById('current-photo').style.display = 'none';
            }

            document.getElementById('editNewsForm').action = `/admin/news/${newsId}`;

            let editModal = new bootstrap.Modal(document.getElementById('editModal'));
            editModal.show();
        });
    });

    // Handling news delete button
    let deleteNewsButtons = document.querySelectorAll('.delete');
    deleteNewsButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            let newsId = this.getAttribute('data-news-id');
            document.getElementById('delete-form').action = `/admin/news/${newsId}`;

            let deleteModal = new bootstrap.Modal(document.getElementById('deleteModal'));
            deleteModal.show();
        });
    });


    // Start Tender
    // Handling tender edit button
    let editTenderButtons = document.querySelectorAll('.edit-tender-button');
    editTenderButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            let tenderId = this.getAttribute('data-tender-id');
            let tenderTitle = JSON.parse(this.getAttribute('data-tender-title'));
            let tenderDescription = JSON.parse(this.getAttribute('data-tender-description'));
            let tenderStartDate = this.getAttribute('data-tender-start-date');
            let tenderEndDate = this.getAttribute('data-tender-end-date');
            let tenderFilePath = this.getAttribute('data-tender-file-path');

            document.getElementById('edit-id').value = tenderId;

            document.getElementById('edit-title-ru').value = tenderTitle['ru'] || '';
            document.getElementById('edit-title-tj').value = tenderTitle['tj'] || '';
            document.getElementById('edit-title-en').value = tenderTitle['en'] || '';

            document.getElementById('edit-description-ru').value = tenderDescription['ru'] || '';
            document.getElementById('edit-description-tj').value = tenderDescription['tj'] || '';
            document.getElementById('edit-description-en').value = tenderDescription['en'] || '';

            document.getElementById('edit-start-date').value = tenderStartDate;
            document.getElementById('edit-end-date').value = tenderEndDate;
            document.getElementById('edit-file-path').dataset.filePath = tenderFilePath;

            document.getElementById('editTenderForm').action = `/admin/tenders/${tenderId}`;

            let editTenderModal = new bootstrap.Modal(document.getElementById('editTenderModal'));
            editTenderModal.show();
        });
    });

    // Handling tender delete button
    let deleteTenderButtons = document.querySelectorAll('.delete-tender-button');
    deleteTenderButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            let newsId = this.getAttribute('data-tender-id');
            document.getElementById('delete-form').action = `/admin/tenders/${newsId}`

            let deleteModal = new bootstrap.Modal(document.getElementById('deleteModal'));
            deleteModal.show();
        });
    });

    // Start Vacancies
    // Handling vacancy edit button
    let editVacancyButton = document.querySelectorAll('.edit-vacancy-button');
    editVacancyButton.forEach(function (button) {
        button.addEventListener('click', function () {
            let vacancyId = this.getAttribute('data-vacancy-id');
            let vacancyTitle = JSON.parse(this.getAttribute('data-vacancy-title'));
            let vacancyDescription = JSON.parse(this.getAttribute('data-vacancy-description'));
            let vacancyLocation = JSON.parse(this.getAttribute('data-vacancy-location'));
            let vacancyExpiryDate = this.getAttribute('data-vacancy-expiry-date');

            document.getElementById('edit-id').value = vacancyId;

            document.getElementById('edit-title-ru').value = vacancyTitle['ru'] || '';
            document.getElementById('edit-title-tj').value = vacancyTitle['tj'] || '';
            document.getElementById('edit-title-en').value = vacancyTitle['en'] || '';

            document.getElementById('edit-description-ru').value = vacancyDescription['ru'] || '';
            document.getElementById('edit-description-tj').value = vacancyDescription['tj'] || '';
            document.getElementById('edit-description-en').value = vacancyDescription['en'] || '';

            document.getElementById('edit-location-ru').value = vacancyLocation['ru'] || '';
            document.getElementById('edit-location-tj').value = vacancyLocation['tj'] || '';
            document.getElementById('edit-location-en').value = vacancyLocation['en'] || '';

            document.getElementById('edit-expiry-date').value = vacancyExpiryDate;

            document.getElementById('editVacancyForm').action = `/admin/vacancies/${vacancyId}`;

            let editVacancyModal = new bootstrap.Modal(document.getElementById('editVacancyModal'));
            editVacancyModal.show();
        })
    });


    // Handling vacancy delete button
    let deleteVacancyButton = document.querySelectorAll('.delete-vacancy-button');
    deleteVacancyButton.forEach(function (button) {
        button.addEventListener('click', function () {
            let vacancyId = this.getAttribute('data-vacancy-id');
            document.getElementById('delete-form').action = `/admin/vacancies/${vacancyId}`;

            let deleteModal = new bootstrap.Modal(document.getElementById('deleteVacancyModal'));
            deleteModal.show();
        });
    });
});
